import { render, staticRenderFns } from "./Credits.vue?vue&type=template&id=1a991934&scoped=true&"
var script = {}
import style0 from "./Credits.vue?vue&type=style&index=0&id=1a991934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a991934",
  null
  
)

component.options.__file = "Credits.vue"
export default component.exports